import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const inputClass =
  "rounded-none border-navy-ink/15 bg-white font-light text-navy-ink placeholder:text-mist/50 focus-visible:ring-gold";

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="mb-2 block text-[10px] uppercase tracking-[0.3em] text-mist">{label}</label>
    {children}
    {hint && <p className="mt-1.5 text-[11px] text-mist/70">{hint}</p>}
  </div>
);

export const TextField = ({ label, hint, value, onChange, testId, multiline, ...rest }) => (
  <Field label={label} hint={hint}>
    {multiline ? (
      <Textarea value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={inputClass} rows={3} {...rest} />
    ) : (
      <Input value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={inputClass} {...rest} />
    )}
  </Field>
);

export const PrimaryButton = ({ children, className = "", ...rest }) => (
  <button
    className={`border border-gold bg-gold px-6 py-3 text-[11px] uppercase tracking-[0.3em] text-navy transition-colors duration-300 hover:bg-transparent hover:text-gold disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...rest }) => (
  <button
    className={`border border-navy-ink/20 px-5 py-2.5 text-[10px] uppercase tracking-[0.3em] text-navy-ink transition-colors duration-300 hover:border-gold hover:text-gold disabled:opacity-50 ${className}`}
    {...rest}
  >
    {children}
  </button>
);
